import React from 'react';
import { canViewCorrectAnswers, noAnswerProvided, renderCorrectnessIcon } from '@/components/staffer/Grading/utils';
import { StudentAnswerProps } from '@/components/staffer/Grading/types';

export const imcAnswerAttributes = ['correct_choices', 'image_options'];

const ImageMultipleChoiceQuestionStudentAnswer = ({ question, questionAnswer }: StudentAnswerProps) => {
  const showCorrectAnswers = canViewCorrectAnswers();

  const studentAnswerCells = () => {
    let optionsToDisplay;

    if (question.correct_choices.length !== 1) {
      optionsToDisplay = Object.keys(question.image_options);
    } else {
      optionsToDisplay = question.correct_choices;
    }

    return (
      optionsToDisplay.map((imageOption) => {
        const answerChoiceIsCorrect = question.correct_choices.includes(imageOption);
        const answers = (questionAnswer.answer || '').split(',');
        const isCorrect = answerChoiceIsCorrect && answers.includes(imageOption);

        return (
          <tr key={`${questionAnswer.id}-imc-option-${imageOption}`}>
            <td className="tw-text-center tw-align-middle">
              <img alt="" className="thumbnail" src={question.image_options[imageOption].image.url} />
            </td>
            <td className="tw-text-center tw-align-middle">
              {answers.includes(imageOption) && renderCorrectnessIcon(isCorrect, '!tw-text-2xl')}
            </td>
            {showCorrectAnswers && (
              <td className="tw-text-center tw-align-middle">
                {answerChoiceIsCorrect && renderCorrectnessIcon(answerChoiceIsCorrect, '!tw-text-2xl')}
              </td>
            )}
          </tr>
        );
      })
    );
  };

  if (!questionAnswer) return noAnswerProvided();

  let headerCells;

  if (questionAnswer.gather_attempts && questionAnswer.gather_attempts.length !== 0) {
    headerCells = (
      <>
        <td>Answer Choices</td>
        <td>Selected Answer (1st)</td>
        <td>Selected Answer (2nd)</td>
        <td>Correct Selections</td>
      </>
    );
  } else {
    headerCells = (
      <>
        <td className="tw-text-center tw-align-middle">Answer Choice</td>
        <td className="tw-text-center tw-align-middle">Selected Answer</td>
        {showCorrectAnswers && <td className="tw-text-center tw-align-middle">Correct Selection</td>}
      </>
    );
  }

  return (
    <table className="multiple-choice-answer-preview answer-preview-table tw-min-w-[29em]">
      <thead>
        <tr>
          {headerCells}
        </tr>
      </thead>
      <tbody>
        {studentAnswerCells()}
      </tbody>
    </table>
  );
};

export default ImageMultipleChoiceQuestionStudentAnswer;
